<template>
  <div class="my-3">
    <b-row align-v="center">
      <b-col :sm="labelWidth" class="text-left">
        <label :class="validationStyle" class="mb-0 align-middle">{{this.label}} <span v-if="required && label" :class="validationState?'form-valid':'form-invalid'" style="font-size: 1rem;">*</span></label>
      </b-col>
      <b-col :sm="inputWidth">
        <b-form-textarea style="min-height: 70px" :value="value" class="FITInput" v-bind:class="{ disabled: disabled }" :placeholder="this.placeholder" :disabled="this.disabled" :rows="this.rows" :max-rows="this.maxRows" @input="change($event)" :state="validationState"></b-form-textarea>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="end">
      <b-col :sm="inputWidth">
        <span class="form-invalid" v-if="validationState==false">{{errorMsg}}<br/></span>
        <span style="display: none;">{{getRuleByField}}{{validatorObject}}</span>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import FITValidationBus from './FITValidationBus';

const ignoreGroup = [
  'caseDetail',
  'createCase',
];
export default{
  name: 'FITTextarea',
  props: {
    alignV: {
      type: String,
      default: 'center'
    },
    label: String,
    placeholder: String,
    disabled: Boolean,
    value: String, // V-model Value
    width: {
      type: Number,
      default: 10
    },
    rows: {
      type: Number,
      default: 3
    },
    maxRows: {
      type: Number,
      default: 6
    },
    rule: { type: Object, default: function() { return {} } },
    field: String,
    vuexObject: { type: String, default: "default" },
    vuexModule: { type: String, default: "Validation" },
    vuexMutation: { type: String, default: "setValidationResult" },

  },

  data() {
    return {
      inputWidth: this.width,
      fieldInput: this.value,
      vuexValidator: false,
    }
  },

  validations() {
    if (this.required == true) {
      return {
        fieldInput: { required },
      }
    } else {
      return {
        fieldInput: {}
      }
    }
  },
  watch: {

    fieldInput: {
      deep: true,
      handler(val) {
        // console.log(val);
        this.$emit('input', val);
        this.$emit('validation', this.validationState);

      }
    },
        value(val) {
          this.change(val);
      }
  },
  mounted() {
    this.labelCheck(this.label);
    if (this.fieldInput) {
      this.$v.fieldInput.$touch();
    }
    // onListen Reset 
    FITValidationBus.$on('reset', (value) => {
      if (value) {
        // console.log("onEmit");
        if (this.$v) {
          this.$nextTick(() => { this.$v.$reset() })
        }
      }
    });

    // onListen dirty 
    FITValidationBus.$on('dirty', (value) => {
      if (value) {
        if (value == this.vuexObject) {
          // console.log("onDirty");
        this.$nextTick(() => { this.$v.fieldInput.$touch() });
          this.$emit('validation', this.validationState);
        }
      }
    });

    // Initial Dirty
    this.$nextTick(() => { this.$v.$reset() })
  },
  computed: {
    getRuleByField() {
      let rules = this.$store.getters[`${this.vuexModule}/getRuleByField`];
      let result = rules(this.field);
      if (Object.keys(result).length > 0) {
        this.vuexValidator = true;
        // console.log(result);
      } else {
        this.vuexValidator = false;
      }
      return result;
    },
    required() {
      if (this.vuexValidator) {
        return true;
      }
      if (this.rule.required == true) {
        return true;
      } else {
        return false;
      }
    },
    getValidationFinalCheck() {
      if (!this.vuexModule) {
        return false;
      }
      if(ignoreGroup.includes( this.vuexObject)){
          return false; 
      }
      return this.$store.getters[`${this.vuexModule}/getValidationFinalCheck`];
    },
    errorMsg() {
      return this.$t('validation.errorMsg.required');
    },
    validatorObject() {
      return this.$v.fieldInput;
    },
    validationState() {
      if ((!this.required) || (this.disabled)) {
        return null;
      }
      if (this.getValidationFinalCheck) {
        this.$v.fieldInput.$touch();
      }
      // Valdiation State Check
      let dirty = this.$v.fieldInput.$dirty;
      let invalid = this.$v.fieldInput.$invalid;
      let state = null;
      if (!dirty) {
        state = null;
      } else {
        if (invalid) {
          state = false;
        } else {
          if (!this.fieldInput) {
            state = null;
          } else {
            state = true;
          }
        }
      }
      // Update to Vuex
      if (this.field) {
        this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
          object: this.vuexObject,
          field: this.field,
          result: state,
        });
      }
      return state;
    },

    validationStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'form-valid'; }
      if (this.validationState == false) { return 'form-invalid'; }
    },

    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    change(event) {
      this.$v.fieldInput.$model = event;
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITTextarea.vue